export default __webpack_public_path__ + "assets/images/9.339077.png";